import { IdentifierValueDto } from "../../models/agency-types";

const byName = (a, b) => a.Name < b.Name ? -1 : 1;

export const getAllowedIdentifiers = (type: IdentifierValueDto, allIdentifiers: any[], filter?: (i) => boolean) => {
	if(type === undefined) {
		return allIdentifiers
			.filter(c => filter?.(c) ?? true)
			.sort(byName);
	}
	const Identifiers = (type.Items ?? [])
		.filter(c => filter?.(c) ?? true)
		.map(c => (allIdentifiers ?? []).find(ac => ac.Code === c.Item.Code))
		.sort(byName);

	return Identifiers;
};

export const getRequiredIdentifiersForType = (type: IdentifierValueDto, allIdentifiers) => 
	getAllowedIdentifiers(type, allIdentifiers, c => c.IsExpected === true);